import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";

export default {
  async getApartmentData(coopId, apartmentId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.apartment, { coopId: coopId, id: apartmentId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async patchApartmentData(coopId, apartmentId, body) {
    try {
      const { data } = await api.patch(
        url(ENDPOINTS.apartment, { coopId: coopId, id: apartmentId }),
        body
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getApartmentResidents(coopId, apartmentId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.residents, { coopId: coopId, id: apartmentId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async postApartmentResidents(coopId, apartmentId, body) {
    try {
      await api.post(
        url(ENDPOINTS.residents, { coopId: coopId, id: apartmentId }),
        body
      );
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getApartmentCars(apartmentId, cooperativeId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.cars, { cId: cooperativeId, id: apartmentId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async postApartmentCars(apartmentId, cooperativeId, body) {
    try {
      const { data } = await api.post(
        url(ENDPOINTS.cars, { id: apartmentId, cId: cooperativeId }),
        body
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async deleteApartmentCar(apartmentId, cooperativeId, carId) {
    try {
      await api.delete(
        url(ENDPOINTS.deleteCar, { id: apartmentId, cooperativeId, carId })
      );
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async deleteApartmentResident(coopId, apartmentId, id) {
    try {
      await api.delete(
        url(ENDPOINTS.changeResidents, {
          coopId: coopId,
          aId: apartmentId,
          id: id,
        })
      );
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async patchApartmentResident(coopId, apartmentId, id, body) {
    try {
      const { data } = await api.patch(
        url(ENDPOINTS.changeResidents, {
          coopId: coopId,
          aId: apartmentId,
          id: id,
        }),
        body
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getApartmentNotifications(apartmentId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.notifications, { aId: apartmentId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getApartmentInvoicing(apartmentId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.invoicing, { aId: apartmentId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async updateApartmentNotifications(apartmentId, body) {
    try {
      const { data } = await api.patch(
        url(ENDPOINTS.notifications, { aId: apartmentId }),
        body
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async updateApartmentInvoicing(apartmentId, body) {
    try {
      const { data } = await api.patch(
        url(ENDPOINTS.invoicing, { aId: apartmentId }),
        body
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async getApartmentDetailData(cId, aId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.apartmentDetail, { cId, aId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
